"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
exports.menu = menu;
var actions = _interopRequireWildcard(require("../actions"));
var _SessionStorage = _interopRequireDefault(require("../../shared/SessionStorage"));
var _constants = _interopRequireDefault(require("../constants"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getMenuState = (appconfig = {}) => {
  const menuExpanded = _SessionStorage.default.get(_constants.default.MENU_EXPANDED);
  if (menuExpanded !== null) {
    return menuExpanded;
  }
  return appconfig && appconfig.collapsedMenu !== undefined ? !appconfig.collapsedMenu : false;
};
const initialState = exports.initialState = {
  isExpanded: getMenuState(),
  solutions: _SessionStorage.default.get(_constants.default.MENU_KEY) || [],
  showBurgerMenu: false
};
function menu(state = initialState, action) {
  switch (action.type) {
    case actions.MENU_TOGGLE:
      return {
        ...state,
        isExpanded: action.payload
      };
    case actions.GET_MENU_DATA_SUCCESS:
      return {
        ...state,
        solutions: action.payload.sitemap || []
      };
    case actions.GET_MENU_DATA_ERROR:
      return {
        ...state,
        solutions: []
      };
    case actions.GET_APP_CONFIG_SUCCESS:
      return {
        ...state,
        isExpanded: getMenuState(action.payload.config)
      };
    case actions.SHOW_BURGER_MENU:
      return {
        ...state,
        showBurgerMenu: {
          ...state.showBurgerMenu,
          ...action.payload
        }
      };
    default:
      return state;
  }
}